import axios from 'axios';

const API_URL = process.env.VUE_APP_REPORT_MANAGER_BASE_URL;

class ReportService {
  async getReportByTerrainId(user_id, terrain_id, end_period, force = false) {
    const url = API_URL + 'report/by_terrain/user_id/' + encodeURI(user_id) + '/terrain_id/' + encodeURI(terrain_id) + '/end_date/' + end_period + '/force/' + force
    return await axios.get(
      url,{ responseType: 'arraybuffer'}
    )
  }
}

export default new ReportService();
